/* Icon.js
 *
 * copyright (c) 2010-2026, Christian Mayer and the CometVisu contributors.
 *
 * This program is free software; you can redistribute it and/or modify it
 * under the terms of the GNU General Public License as published by the Free
 * Software Foundation; either version 3 of the License, or (at your option)
 * any later version.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or
 * FITNESS FOR A PARTICULAR PURPOSE. See the GNU General Public License for
 * more details.
 *
 * You should have received a copy of the GNU General Public License along
 * with this program; if not, write to the Free Software Foundation, Inc.,
 * 59 Temple Place - Suite 330, Boston, MA  02111-1307, USA
 */

qx.Theme.define('cv.theme.dark.Icon', {
  aliases: {
    icon: 'qx/icon/Oxygen',
    'qxl.dialog.icon.cancel': '@MaterialIcons/cancel/18',
    'qxl.dialog.icon.ok': '@MaterialIcons/check/18',
    'qxl.dialog.icon.info': '@MaterialIcons/info/18',
    'qxl.dialog.icon.error': '@MaterialIcons/error/18',
    'qxl.dialog.icon.warning': '@MaterialIcons/warning/18',
    'qxl.dialog.icon.delete': '@MaterialIcons/delete_forever/18'
  }
});
